import(/* webpackMode: "eager", webpackExports: ["NewAppVersionDialog"] */ "/vercel/path0/apps/web/src/app/_common/app-version/new-app-version-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryClientProvider"] */ "/vercel/path0/apps/web/src/providers/query-client-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WagmiProvider"] */ "/vercel/path0/apps/web/src/providers/wagmi-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BaseProviders"] */ "/vercel/path0/packages/ui/dist/base-providers.js");
;
import(/* webpackMode: "eager", webpackExports: ["OnramperProvider"] */ "/vercel/path0/packages/ui/dist/components/onramper.js");
